import { useMemo } from 'react'

import { Tooltip } from 'antd'

import { Text, TextProps } from './BUI/Text'
import { MultiProjectIcons } from './Filters/GenericProjectSelector'
import { Flexbox } from './Flexbox'
import {
  ProjectIcon,
  ProjectIconWrapper,
  WrapperProps,
  getProjectColour,
} from './ProjectIcon'

import { pluralise, createCommaSeparatedString } from '@/utils/index'

import { ProjectLike } from 'types/vagueTypes'

type Props = {
  projects: ProjectLike[]
  collapse?: number
  iconSize?: number
  wrapperProps?: WrapperProps
  textProps?: TextProps
}

export const ProjectDisplay: React.FC<Props> = ({
  projects,
  collapse = 2,
  iconSize = 24,
  wrapperProps = { bold: false },
  textProps,
}) => {
  const collapseProjects = useMemo(() => {
    return projects?.length >= collapse
  }, [projects?.length, collapse])

  if (!projects?.length) return null

  if (collapseProjects) {
    return (
      <Tooltip
        title={createCommaSeparatedString(projects.map((p) => p.name))}
        placement="topLeft"
      >
        <Flexbox gap="0.5rem" alignItems="center">
          <MultiProjectIcons>
            <ProjectIcon colour={getProjectColour(projects[0])} size={16} />
            {projects.length > 1 && (
              <ProjectIcon colour={getProjectColour(projects[1])} size={18} />
            )}
            {projects.length > 2 && (
              <ProjectIcon colour={getProjectColour(projects[2])} size={14} />
            )}
          </MultiProjectIcons>
          <Text noVariant={!textProps?.variant} {...textProps}>
            {pluralise(projects.length, 'project')}
          </Text>
        </Flexbox>
      </Tooltip>
    )
  }

  return (
    <Flexbox gap="0.5rem" alignItems="center" flexWrap="wrap">
      {projects.map((project) => (
        <ProjectIconWrapper key={project.id} {...wrapperProps}>
          <ProjectIcon colour={getProjectColour(project)} size={iconSize} />
          <Text noVariant={!textProps?.variant} {...textProps}>
            {project.name}
          </Text>
        </ProjectIconWrapper>
      ))}
    </Flexbox>
  )
}
